import React from "react";
import { Link } from "react-router";
import { Music2 } from "lucide-react";
import { Trans } from "@lingui/react/macro";

const NotFound: React.FC = () => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center px-4 text-center">
      <Music2 className="text-soluud-primary mb-4 h-14 w-14 animate-pulse opacity-60" />
      <span className="from-soluud-secondary to-soluud-primary animated-gradient-text mb-2 bg-gradient-to-r bg-clip-text text-[8rem] leading-none font-extrabold tracking-tight text-transparent sm:text-[10rem]">
        404
      </span>
      <h1 className="text-soluud-text-primary mb-3 text-3xl font-extrabold tracking-tight sm:text-4xl">
        <Trans>Wrong note.</Trans>
      </h1>
      <p className="text-soluud-text-secondary mb-8 max-w-md text-base sm:text-lg">
        <Trans>
          This page isn't in our setlist. Looks like you've wandered off the
          score — let's get you back on track.
        </Trans>
      </p>
      <Link
        to="/"
        className="bg-soluud-primary hover:bg-soluud-primary-hover active:bg-soluud-primary-active focus-visible:ring-soluud-primary inline-flex cursor-pointer items-center rounded-lg px-5 py-2.5 text-sm font-medium text-white shadow-sm transition-all duration-150 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none active:scale-[0.98]"
      >
        <Trans>Back to Home</Trans>
      </Link>
    </div>
  );
};

export default NotFound;
